import { useNavigate } from 'react-router-dom'

import { DashboardNewModalPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DashboardNewModal from 'modules/reports/components/DashboardNewModal'

const DashboardNewModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const { data, loading } = useQuery(DashboardNewModalPageDocument)

  const canManageReports = data?.reports._policies.useReports.can ?? false

  const onClose = () => {
    navigate(navigation.reports.dashboards.list.fullPath())
  }

  const onSuccess = (dashboardId: string) => {
    navigate(navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: dashboardId }))
  }

  if (loading) return null

  return (
    <DashboardNewModal
      onClose={onClose}
      onSuccess={onSuccess}
      canManageReports={canManageReports}
    />
  )
}

export default DashboardNewModalPage
